/** The backend matches on the last ten digits, so the same person typed six
 *  ways is one person. This only formats for display. */

const NON_DIGIT = /\D/g

export function digitsOnly(raw: string | null | undefined): string {
  return (raw ?? '').replace(NON_DIGIT, '')
}

export function looksLikePhone(query: string): boolean {
  const digits = digitsOnly(query)
  return digits.length >= 10 && digits.length >= query.trim().length - 4
}

/** Groups for readability without claiming to know the country's format. */
export function formatPhone(raw: string | null | undefined): string {
  if (!raw) return ''
  const trimmed = raw.trim()
  const digits = digitsOnly(trimmed)
  if (digits.length === 10) return `${digits.slice(0, 5)} ${digits.slice(5)}`
  if (digits.length === 12 && trimmed.startsWith('+')) {
    return `+${digits.slice(0, 2)} ${digits.slice(2, 7)} ${digits.slice(7)}`
  }
  return trimmed
}

/** The patient header is on screen for a whole consultation, in a room other
 *  people walk into. The full number is one tap away. */
export function maskPhone(raw: string | null | undefined): string {
  const digits = digitsOnly(raw)
  if (digits.length < 4) return raw?.trim() ?? ''
  const head = digits.slice(0, 2)
  const tail = digits.slice(-2)
  return `${head}${'•'.repeat(Math.max(digits.length - 4, 2))}${tail}`
}
